// Central API client
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 30000 });

export const generateGcode = async (op, params) => {
  const { data } = await api.post(`/generate/${op}`, params);
  return data;
};

export const validateGcode = async (gcode) => {
  const { data } = await api.post('/gcode/validate', { gcode });
  return data;
};

export const parseGcode = async (gcode) => {
  const { data } = await api.post('/gcode/parse', { gcode });
  return data;
};

export const listOperations = async () => {
  const { data } = await api.get('/operations');
  return data.operations;
};

export const listTools = async () => {
  const { data } = await api.get('/tools');
  return data;
};
export const createTool = async (t) => (await api.post('/tools', t)).data;
export const updateTool = async (id, t) => (await api.put(`/tools/${id}`, t)).data;
export const deleteTool = async (id) => (await api.delete(`/tools/${id}`)).data;

export const listProjects = async () => (await api.get('/projects')).data;
export const getProject = async (id) => (await api.get(`/projects/${id}`)).data;
export const createProject = async (p) => (await api.post('/projects', p)).data;
export const updateProject = async (id, p) => (await api.put(`/projects/${id}`, p)).data;
export const deleteProject = async (id) => (await api.delete(`/projects/${id}`)).data;

export const listMaterials = async () => (await api.get('/materials')).data;
export const calcFeedSpeed = async (req) => (await api.post('/feedspeed/calculate', req)).data;

export const parseDxf = async (file) => {
  const fd = new FormData();
  fd.append('file', file);
  const { data } = await api.post('/dxf/parse', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
  return data;
};
